import { render, staticRenderFns } from "./sac-t-kodinpro-guestmain.vue?vue&type=template&id=1b66c8a4&scoped=true"
import script from "./sac-t-kodinpro-guestmain.vue?vue&type=script&lang=js"
export * from "./sac-t-kodinpro-guestmain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../sa-platform-cli/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b66c8a4",
  null
  
)

export default component.exports